import { Uploader } from "./upload_common";
import { S3Upload } from "./s3";

class GalleryUploader extends Uploader {

    constructor(root) {
        super(root)
        this.files = []
    }

    validateRow(target, files) {
        const container = target.closest('.uploader-container')
        const status = container.querySelector('.upload-status')

        this.files = []

        if (files.length < 1 || files.length > 360) {
            this.statusError(status, 'Please upload 1..360 images (.jpg, .jpeg, .png)')
            return
        }

        for (let file of files) {
            if (!this.acceptedImageTypes.test(file.type)) {
                this.statusError(status, 'Please upload 1..360 images (.jpg, .jpeg, .png)')
                return
            }
        }

        this.statusSuccess(status, `${files.length} files selected`)

        this.files = files
        this.submitButton.removeAttribute('disabled')
    }


    doSubmit() {
        if (this.files) {
            let result = this.postVariant()
            if (!result?.uuid) {
                this.submitted = false
                const message = (result?.errors && Object.values(result.errors).flat()[0]) || 'Upload failed. Please try again.'
                this.uploadFailed(message)
                return
            }
            const variant = result
            const uploader = new S3Upload(variant, this)
            uploader.enqueue("images", 1, this.files)
            uploader.upload()
        }
    }
}


window.addEventListener('load', () => {
    let root = document.querySelector('#gallery_upload')
    if (root !== null) {
        const uploader = new GalleryUploader(root)
    }
})
